import { z } from 'zod';

export const MonitoringStatsSchema = z.object({
    total: z.number().optional(),
    active: z.number().optional(),
    critical: z.number().optional(),
    high: z.number().optional(),
    medium: z.number().optional(),
    low: z.number().optional(),
    byCategory: z.record(z.number()).optional(),
    trend: z.array(z.object({
        date: z.string(),
        count: z.number()
    })).optional()
});

export const CreateMonitoringStatsSchema = MonitoringStatsSchema.omit({ id: true });
export const UpdateMonitoringStatsSchema = MonitoringStatsSchema;